import { render, staticRenderFns } from "./DuplicateModal.vue?vue&type=template&id=072758af&scoped=true&"
import script from "./DuplicateModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateModal.vue?vue&type=style&index=0&id=072758af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072758af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
